import React, { useEffect, useRef } from "react";
import Button from "../components/Button";
import SectionHeader from "../components/SectionHeader";
import heroVideo from '../assets/Ultra_premium_SaaS_technology.mp4';
import heroPoster from '../assets/bg.png';
import { ImageTextCarousel } from "../components/ImageTextCarousel";
import fazendaDesktop from '../assets/fazenda-leiteira.webp';
import fazendaMobile from '../assets/fazenda-leiteira-mobile.webp';
import obrasDesktop from '../assets/controle-obras.png';
import obrasMobile from '../assets/controle-obras-mobile.png';
import locacaoDesktop from '../assets/locacao-equipamentos.png';
import locacaoMobile from '../assets/locacao-equipamentos-mobile.png';



const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const solutions = [
    {
      icon: "fas fa-cow",
      title: "Fazenda Leiteira",
      desc: "Controle produção, animais, custos, estoque, reprodução, saúde e lucratividade da propriedade.",
    },
    {
      icon: "fas fa-hard-hat",
      title: "Controle de Obras",
      desc: "Acompanhe obras, etapas, equipes, materiais, cronograma, custos e evolução em tempo real.",
    },
    {
      icon: "fas fa-truck-ramp-box",
      title: "LocaFácil Obras",
      desc: "Gerencie equipamentos, contratos, reservas, entregas, devoluções, manutenção e faturamento.",
    },
    {
      icon: "fas fa-robot",
      title: "Atende24h IA",
      desc: "Atendimento inteligente no WhatsApp, automações, histórico, transferência humana e respostas rápidas.",
    },
  ];

  const automations = [
    "Avisos de vencimento pelo WhatsApp",
    "Notificações de eventos importantes",
    "Alertas operacionais automáticos",
    "Integração com Chatwoot, N8N e Evolution API",
  ];

  const slides = [
    {
      title: 'Fazenda Leiteira',
      text: 'Gestão completa da fazenda, produção, reprodução, saúde e financeiro.',
      image: fazendaDesktop,
      mobileImage: fazendaMobile,
    },
    {
      title: 'Controle de Obras',
      text: 'Gerencie obras, equipes, cronogramas e custos em tempo real.',
      image: obrasDesktop,
      mobileImage: obrasMobile,
    },
    {
      title: 'LocaFácil Obras',
      text: 'Controle equipamentos, contratos, clientes e faturamento.',
      image: locacaoDesktop,
      mobileImage: locacaoMobile,
    },
  ];


  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5;
    }
  }, []);

  return (
    <>
      {/* HERO */}
      <section
        style={{
          marginTop: "80px",
          padding: "5.5rem 0",
          background:
            "radial-gradient(circle at top left, rgba(56,189,248,.18), transparent 32%), linear-gradient(135deg, #020617 0%, #0f172a 55%, #111827 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          poster={heroPoster}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
          }}
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
        {/* MÁSCARA */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            background: `
              linear-gradient(
                90deg,
                rgba(2,6,23,.96) 0%,
                rgba(2,6,23,.92) 35%,
                rgba(2,6,23,.75) 65%,
                rgba(2,6,23,.55) 100%
              )
            `,
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(90deg, rgba(255,255,255,.04) 1px, transparent 1px), linear-gradient(rgba(255,255,255,.04) 1px, transparent 1px)",
            backgroundSize: "44px 44px",
            opacity: 0.18,
          }}
        />

        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "4rem",
              alignItems: "center",
            }}
          >
            <div>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: ".5rem",
                  padding: ".45rem .85rem",
                  borderRadius: "999px",
                  background: "rgba(14,165,233,.12)",
                  border: "1px solid rgba(56,189,248,.25)",
                  color: "#7dd3fc",
                  fontSize: ".85rem",
                  fontWeight: 600,
                  marginBottom: "1.5rem",
                }}
              >
                <i className="fas fa-bolt" />
                Sistemas inteligentes para empresas que precisam de controle
              </div>

              <h1
                style={{
                  fontSize: "clamp(2.4rem, 3vw, 4.4rem)",
                  fontWeight: 900,
                  color: "#fff",
                  lineHeight: 1.05,
                  marginBottom: "1.5rem",
                  letterSpacing: "-1.5px",
                }}
              >
                Sistemas inteligentes para gestão{" "}
                <span
                  style={{
                    background:
                      "linear-gradient(135deg, #38bdf8, #22d3ee, #60a5fa)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                   rural, obras, locações e atendimento
                </span>
              </h1>

              <p
                style={{
                  fontSize: "1.2rem",
                  color: "#cbd5e1",
                  lineHeight: 1.7,
                  marginBottom: "2rem",
                  maxWidth: "680px",
                }}
              >
                Produtos digitais criados para transformar rotinas complexas em controle simples, com dados organizados, alertas automáticos e atendimento conectado ao WhatsApp.
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                  marginBottom: "2rem",
                }}
              >
                <Button to="/contato">
                  <i className="fab fa-whatsapp" /> Solicitar Demonstração
                </Button>

                <Button variant="secondary" to="/solucoes">
                  Ver Soluções
                </Button>
              </div>

              <div style={{ display: "flex", gap: ".75rem", flexWrap: "wrap" }}>
                {["Controle em tempo real", "Alertas automáticos", "Atendimento integrado"].map(
                  (badge) => (
                    <div
                      key={badge}
                      style={{
                        background: "rgba(255,255,255,0.06)",
                        border: "1px solid rgba(255,255,255,0.12)",
                        padding: ".6rem 1rem",
                        borderRadius: "999px",
                        color: "#e2e8f0",
                        fontSize: ".85rem",
                        display: "flex",
                        alignItems: "center",
                        gap: ".5rem",
                      }}
                    >
                      <i
                        className="fas fa-check-circle"
                        style={{ color: "#38bdf8" }}
                      />
                      {badge}
                    </div>
                  )
                )}
              </div>
            </div>

            {/* MOCKUP */}
            <div>
              <div
                style={{
                  maxWidth: "460px",
                  margin: "0 auto",
                  borderRadius: "28px",
                  padding: "1rem",
                  background:
                    "linear-gradient(145deg, rgba(255,255,255,.18), rgba(255,255,255,.05))",
                  border: "1px solid rgba(255,255,255,.16)",
                  boxShadow: "0 30px 80px rgba(0,0,0,.45)",
                  backdropFilter: "blur(18px)",
                }}
              >
                <div
                  style={{
                    borderRadius: "22px",
                    background: "#020617",
                    overflow: "hidden",
                    border: "1px solid rgba(148,163,184,.25)",
                  }}
                >
                  <div
                    style={{
                      padding: "1rem",
                      borderBottom: "1px solid rgba(148,163,184,.2)",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <strong style={{ color: "#fff" }}>Painel Atenda24h</strong>
                    <span
                      style={{
                        color: "#22c55e",
                        fontSize: ".8rem",
                        background: "rgba(34,197,94,.12)",
                        padding: ".25rem .6rem",
                        borderRadius: "999px",
                      }}
                    >
                      Online
                    </span>
                  </div>

                  <div style={{ padding: "1rem", display: "grid", gap: "1rem" }}>
                    {[
                      ["Eventos hoje", "18", "fas fa-calendar-check"],
                      ["Alertas enviados", "42", "fab fa-whatsapp"],
                      ["Processos ativos", "7", "fas fa-diagram-project"],
                    ].map(([label, value, icon]) => (
                      <div
                        key={label}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "1rem",
                          borderRadius: "16px",
                          background: "rgba(15,23,42,.9)",
                          border: "1px solid rgba(148,163,184,.15)",
                        }}
                      >
                        <div style={{ display: "flex", gap: ".75rem" }}>
                          <i
                            className={icon}
                            style={{ color: "#38bdf8", fontSize: "1.2rem" }}
                          />
                          <span style={{ color: "#cbd5e1" }}>{label}</span>
                        </div>
                        <strong style={{ color: "#fff", fontSize: "1.4rem" }}>
                          {value}
                        </strong>
                      </div>
                    ))}

                    <div
                      style={{
                        marginTop: ".5rem",
                        padding: "1rem",
                        borderRadius: "16px",
                        background:
                          "linear-gradient(135deg, rgba(14,165,233,.18), rgba(34,211,238,.08))",
                        border: "1px solid rgba(56,189,248,.25)",
                        color: "#e0f2fe",
                        lineHeight: 1.5,
                      }}
                    >
                      <strong>WhatsApp automático:</strong>
                      <br />
                      “Olá! Seu contrato de locação vence amanhã. Deseja renovar?”
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ width: '100%', padding: 0, overflow: 'hidden' }}>
        <SectionHeader
          title="Nossas Soluções"
          subtitle="Conheça nossos softwares especializados para diferentes segmentos."
        />
        <ImageTextCarousel slides={slides} autoPlayInterval={7000} />
      </section>

      {/* SOLUÇÕES */}
      <section id="servicos" style={{ padding: "5rem 0", background: "var(--bg-tertiary)" }}>
        <div className="container">
          <SectionHeader
            title="Soluções para setores reais"
            subtitle="Sistemas próprios, modernos e pensados para operações que precisam de controle, dados e automação."
          />

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "1.5rem",
            }}
          >
            {solutions.map((item) => (
              <div
                key={item.title}
                style={{
                  background: "var(--bg-primary)",
                  border: "1px solid rgba(148,163,184,.18)",
                  borderRadius: "24px",
                  padding: "2rem",
                  boxShadow: "0 16px 40px rgba(15,23,42,.08)",
                }}
              >
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "18px",
                    background:
                      "linear-gradient(135deg, rgba(14,165,233,.18), rgba(34,211,238,.12))",
                    color: "var(--primary)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    marginBottom: "1.25rem",
                  }}
                >
                  <i className={item.icon} />
                </div>

                <h3 style={{ marginBottom: ".75rem" }}>{item.title}</h3>
                <p style={{ color: "var(--gray)", lineHeight: 1.7 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AUTOMAÇÕES */}
      <section style={{ padding: "5rem 0", background: "var(--card-bg)" }}>
        <div className="container">
          <SectionHeader
            title="O diferencial: automação conectada ao software"
            subtitle="Não é apenas um sistema. É uma operação inteligente que avisa, cobra, lembra, organiza e reduz trabalho manual."
          />

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "2rem",
              alignItems: "center",
            }}
          >
            <div>
              {automations.map((item) => (
                <div
                  key={item}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    padding: "1rem 0",
                    borderBottom: "1px solid rgba(148,163,184,.16)",
                  }}
                >
                  <span
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "50%",
                      background: "rgba(34,197,94,.12)",
                      color: "#22c55e",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i className="fas fa-check" />
                  </span>
                  <strong>{item}</strong>
                </div>
              ))}
            </div>

            <div
              style={{
                borderRadius: "26px",
                padding: "2rem",
                background:
                  "linear-gradient(135deg, var(--primary), var(--accent))",
                color: "#fff",
                boxShadow: "0 24px 60px rgba(14,165,233,.25)",
              }}
            >
              <h3 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                Eventos que viram ações automáticas
              </h3>
              <p style={{ lineHeight: 1.7, opacity: 0.92 }}>
                Um vencimento, uma manutenção, uma etapa de obra, uma cobrança,
                uma consulta ou uma movimentação financeira podem disparar
                mensagens, tarefas, tickets e alertas automaticamente.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* STACK */}
      <section id="tecnologias" style={{ padding: "4rem 0", background: "var(--bg-tertiary)" }}>
        <div className="container">
          <SectionHeader
            title="Tecnologias que usamos"
            subtitle="Base moderna para construir produtos seguros, escaláveis e integrados."
          />

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
              gap: "1.25rem",
            }}
          >
            {[
              ["fab fa-react", "React"],
              ["fab fa-node-js", "Node.js"],
              ["fas fa-database", "MongoDB/Postgres"],
              ["fab fa-whatsapp", "WhatsApp"],
              ["fas fa-project-diagram", "N8N"],
              ["fas fa-headset", "Chatwoot"],
            ].map(([icon, title]) => (
              <div
                key={title}
                style={{
                  padding: "1.5rem",
                  borderRadius: "18px",
                  background: "var(--bg-primary)",
                  border: "1px solid rgba(148,163,184,.16)",
                  textAlign: "center",
                }}
              >
                <i
                  className={icon}
                  style={{
                    fontSize: "2rem",
                    color: "var(--primary)",
                    marginBottom: ".75rem",
                  }}
                />
                <div style={{ fontWeight: 700 }}>{title}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        style={{
          padding: "5rem 0",
          background:
            "linear-gradient(135deg, #0284c7, #06b6d4)",
        }}
      >
        <div className="container" style={{ textAlign: "center", color: "white" }}>
          <h2 style={{ fontSize: "clamp(2rem, 4vw, 3rem)", marginBottom: "1rem" }}>
            Vamos transformar sua ideia em um Sistema de verdade?
          </h2>
          <p
            style={{
              fontSize: "1.15rem",
              opacity: 0.92,
              marginBottom: "2rem",
              maxWidth: "720px",
              marginInline: "auto",
              lineHeight: 1.7,
            }}
          >
            Criamos sistemas sob medida com painéis, relatórios, automações,
            alertas por WhatsApp e estrutura pronta para crescer.
          </p>

          <Button variant="white" to="/contato">
            <i className="fab fa-whatsapp" style={{ marginRight: ".5rem" }} />
            Falar sobre meu projeto
          </Button>
        </div>
      </section>
    </>
  );
};

export default Home;